import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

document.addEventListener("turbo:load", () => {
  flatpickr("[data-behavior='flatpickr-time']", {
    enableTime: true,
    "locale": Russian,
    defaultDate: new Date(),
    minDate: new Date(),
    disableMobile: true,
    dateFormat: 'Z',
    altInput: true,
    altFormat: 'Y-m-d H:i'
  })
})
